jQuery(function ($) {

    var listNews = $('.list-news');
    listNews.append('<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-viewmore"><a href="#" class="viewmore">Xem thêm</a></div>');
    var button = $('.list-news .btn-viewmore');

    if (listNews.data('itemCount') < 9) {
        button.hide();
    }
    var page = 2;
    var loading = false;

    $('body').on('click', '.viewmore', function () {

        if (!loading) {
            loading = true;
            var data = {
                action: 'be_ajax_load_more',
                nonce: beloadmore.nonce,
                page: page,
                query: beloadmore.query,
            };

            if (_.has(window, 'category_slug')) {
                data.query.category_name = window.category_slug;
            }

            $.post(beloadmore.url, data, function (res) {
                if (res.success) {
                    $('.list-news').append(res.data.data).show('slow');
                    if (res.data.size === beloadmore.query.posts_per_page) {
                        $('.list-news').append(button);

                        //$('html, body').animate({
                        //    scrollTop:
                        //}, 1000);

                    } else {
                        $('.btn-viewmore').css('margin-top', '0px');
                        $('.btn-viewmore').html('');
                    }

                    page = page + 1;
                    loading = false;
                } else {
                    // console.log(res);
                }
            }).fail(function (xhr, textStatus, e) {
                // console.log(xhr.responseText);
            });

            return false;
        }
    });

});